module.exports = __webpack_public_path__ + "static/media/package-top.ae2d8861.png";